var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightSmallOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2810_356",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 6,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3677 7.66116C10.3614 7.65408 10.3548 7.64714 10.348 7.64035C10.3423 7.63464 10.3365 7.6291 10.3306 7.62372L6.35263 3.64568C6.15737 3.45042 5.84103 3.45066 5.64607 3.64622C5.4511 3.84178 5.45134 4.1586 5.6466 4.35386L9.2881 7.99541L5.64896 11.646C5.45401 11.8416 5.45413 12.1585 5.64924 12.3539C5.84435 12.5494 6.16056 12.5492 6.35552 12.3537L10.2716 8.42526C10.3017 8.40599 10.3302 8.38315 10.3566 8.35676C10.5476 8.16517 10.5512 7.8572 10.3677 7.66116Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2810_356)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightSmallOutlined);
export default __webpack_public_path__ + "static/media/chevron-right-small-outlined.5959fddf4d15535e238bc718ec04bd2d.svg";
export { ForwardRef as ReactComponent };